export const produtoModais = {
  cadastroProduto: 'cadastroProduto',
  visualizacaoProduto: 'visualizacaoProduto',
  buscaAvancada: 'buscaAvancada',
};
